export default __webpack_public_path__ + "static/general_healthcare_b.367aa37042b4709e6c0181e96a8be4e4.png";